'use es6';

import { debounce } from 'underscore';
import EventBus from 'EmailEditorUI/legacyCoffee/lib/eventBusEmailDnd';
export function focusIframeFromParent() {
  const iframe = document.getElementById('contentEditor-preview');
  if (iframe) {
    iframe.focus();
  }
}
export const debouncedRerenderPreview = debounce(() => EventBus.trigger('saveAndTriggerRefresh'), 1000);
export function toggleCustomSidebarPanelSkeleton(isCustomEmail) {
  const contentPanelSkeleton = document.querySelector('.content-panel-skeleton');
  if (contentPanelSkeleton) {
    contentPanelSkeleton.classList.toggle('isCustomEmail', isCustomEmail);
  }
}
export function getContentEditorPreviewIframe() {
  return document.querySelector('#contentEditor-preview');
}
export function getContentEditorSidebarIframe() {
  return document.querySelector('#contentEditor-sidebar');
}
export function getSidebarIframeWrapper() {
  return document.querySelector('.sidebar-iframe-wrapper');
}
export function getContentEditorSidebar() {
  return document.querySelector('.contentEditor-sidebar');
}
export function removeSidebarSkeleton() {
  const contentEditorSidebar = getContentEditorSidebar();
  const sidebarIframeWrapper = getSidebarIframeWrapper();
  const sidebarSkeleton = document.querySelector('.sidebar-skeleton, .template-sidebar-skeleton');
  if (sidebarSkeleton) {
    sidebarSkeleton.remove();
  }
  if (contentEditorSidebar) {
    contentEditorSidebar.classList.remove('has-skeleton');

    // Remove inline styles which were added to keep skeleton width intact
    requestAnimationFrame(() => {
      contentEditorSidebar.style.width = '';
      contentEditorSidebar.style.flexShrink = '';
    });
  }
  if (sidebarIframeWrapper) {
    sidebarIframeWrapper.classList.remove('hidden');
  }
}